module.exports = __webpack_public_path__ + "static/img/li.86ee180.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/li.png
// module id = H/NI
// module chunks = 9